<!--
 * @Author: your name
 * @Date: 2020-12-25 16:12:53
 * @LastEditTime: 2020-12-25 17:11:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/personalmessage/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-16 14:20:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/personalmessage/index.vue
-->
<template>
  <div>
    <title-bar-back :title="'个人信息'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 头部信息 -->
    <div class="top_per bottom_line">
      <van-uploader
        :after-read="afterRead"
        v-model="fileList"
        result-type="file"
        max-count="1"
        :deletable="false"
      >
        <img
          :src="
            getUserInfo.avatarUrl === null ? avatarImg : getUserInfo.avatarUrl
          "
          alt=""
          class="per_photo"
        />
        <!-- <img :src="avatarImg" alt="" class="per_photo" /> -->
      </van-uploader>
      <div class="per_name font12 font_weight400">
        点击修改头像
      </div>
    </div>
    <!-- 昵称 -->
    <div class="item_item bottom_line clearfix" @click="goNickname">
      <div class="left font14 font_weight400 colo0">昵称</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_det font14 font_weight400">
        {{ getUserInfo.username }}
      </div>
    </div>
    <!-- 性别 -->
    <div class="item_item bottom_line clearfix">
      <div class="left font14 font_weight400 colo0 colo0">性别</div>
      <div class="right font14 font_weight400">
        <van-radio-group
          v-model="radio"
          direction="horizontal"
          checked-color="#BF9264"
          @change="genderChange"
        >
          <van-radio name="1">男</van-radio>
          <van-radio name="2">女</van-radio>
        </van-radio-group>
      </div>
    </div>
    <!-- 生日 -->
    <div class="item_item bottom_line clearfix" @click="showSelectDate = true">
      <div class="left font14 font_weight400 colo0 ">生日</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_det font14 font_weight400">
        <!-- {{ getUserInfo.birthday || "选择生日" }} -->
        {{ meDate || "选择生日" }}
      </div>
    </div>
    <!-- 城市 -->
    <div class="item_item bottom_line clearfix" @click="goAddress">
      <div class="left font14 font_weight400 colo0 ">城市</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_det font14 font_weight400">
        {{ getUserInfo.city || "选择城市" }}
      </div>
    </div>
    <!-- 个性签名 -->
    <div class="item_item clearfix" @click="goSign">
      <div class="left font14 font_weight400 colo0 ">个性签名</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_det font14 font_weight400">
        {{ getUserInfo.signature || "请填写你的个性签名" }}
      </div>
    </div>
    <!-- 生日选择器 -->
    <van-overlay :show="showSelectDate" @click="showSelectDate = false">
      <div class="date_bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="dateConfirm"
        />
      </div>
    </van-overlay>
    <!-- 地址选择器 -->
    <div class="font0">
      <address-select-sheet
        v-if="showAddressSelectSheet"
        @closeSheet="closeSheet"
        @getSelectAddress="getSelectAddress"
      />
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const AddressSelectSheet = () =>
  import("../../product/detail/components/AddressSelectSheet").then(
    m => m.default || m
  );
export default {
  name: "PersonalMessage",
  components: {
    TitleBarBack,
    AddressSelectSheet
  },
  data() {
    return {
      radio: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showSelectDate: false,
      meDate: "",
      avatarImg: require("@/assets/mine/per_photo@2x.png"),
      dataLoading: false,
      showAddressSelectSheet: false,
      fileList: []
    };
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  created() {
    // if (!this.getUserInfo.username) {
    this.getData();
    // }
    // this.meDate = this.getUserInfo.birthday;
  },
  methods: {
    back() {
      this.$router.back();
    },
    getData() {
      // getUserInfo
      this.dataLoading = true;
      this.$store
        .dispatch("mine/getUserInfo")
        .then(() => {
          this.dataLoading = false;
          this.radio = this.getUserInfo.gender + "";
          this.meDate =
            this.getUserInfo.birthday !== null
              ? this.getUserInfo.birthday + ""
              : "";
        })
        .catch(() => {});
    },
    updateData(params) {
      this.$store
        .dispatch("mine/updateUserInfo", { params })
        .then(() => {
          this.dataLoading = false;
          this.getData();
        })
        .catch(() => {});
    },
    // 上传头像
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.$store
        .dispatch("mine/upload", {
          params: {
            file: file.file,
            data: {
              kind: "avatar",
              sourceId: this.getUserInfo.id, //userId
              thumbnail: true
            }
          }
        })
        .then(res => {
          // console.log(res, "res");
          this.$set(this.fileList, 0, { url: res.linkUrl });
          const params = {
            id: this.getUserInfo.id,
            avatarUrl: res.linkUrl
          };
          this.updateData(params);
        })
        .catch(() => {});
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    dateConfirm(date) {
      // console.log(date);
      this.meDate = dayjs(date).format("YYYY-MM-DD");
      this.dataLoading = true;
      const params = {
        id: this.getUserInfo.id,
        birthday: this.meDate
      };
      this.updateData(params);
    },
    // 男女 1男2女
    genderChange(name) {
      if (name !== this.getUserInfo.gender + "") {
        this.dataLoading = true;
        const params = {
          id: this.getUserInfo.id,
          gender: parseInt(name)
        };
        this.updateData(params);
      }
    },
    // 修改昵称
    goNickname() {
      this.$router.push({
        path: "/mine/modifynickname",
        query: {
          id: this.getUserInfo.id,
          name: this.getUserInfo.username
        }
      });
    },
    // 修改个性签名
    goSign() {
      this.$router.push({
        path: "/mine/modifysign",
        query: {
          id: this.getUserInfo.id,
          signature: this.getUserInfo.signature
        }
      });
    },
    // 点击地址
    goAddress() {
      this.showAddressSelectSheet = true;
    },
    // 关闭地址选择器
    closeSheet() {
      this.showAddressSelectSheet = false;
    },
    // 选择地址
    getSelectAddress(address) {
      let city = "";
      address.forEach(item => {
        city += item.areaName;
      });
      // city
      this.dataLoading = true;
      const params = {
        id: this.getUserInfo.id,
        city
      };
      this.updateData(params);
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
::v-deep .van-uploader__preview-image {
  border-radius: 50%;
  width: 58px;
  height: 58px;
}
::v-deep .van-image__img {
  border-radius: 50%;
  width: 58px;
  height: 58px;
}
.top_per {
  background: #fff;
  padding: 15px 0 12px;
  .per_photo {
    width: 58px;
    height: 58px;
    margin: 0 auto;
    border-radius: 50%;
    display: block;
  }
  .per_name {
    // margin-top: 8px;
    color: rgba(0, 0, 0, 0.55);
  }
}
.bottom_line {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.item_mr {
  margin-top: 12px;
}
.item_mr_r {
  margin-left: 12px;
}
.item_item {
  background: #fff;
  padding: 12px;
  line-height: 24px;
  .right_det {
    color: rgba(0, 0, 0, 0.55);
  }
  .right_go {
    width: 24px;
  }
}
.date_bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
